import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/feature/ComicCard';
import ComicCardFeatured from '@/components/feature/ComicCardFeatured';
import { comics, categories } from '@/mocks/comics';
import { siteConfig } from '@/mocks/site';

export default function Home() {
  const featuredComics = comics.filter((c) => c.featured);
  const hotComics = comics.filter((c) => c.hot).slice(0, 6);
  const latestComics = [...comics].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  ).slice(0, 6);

  return (
    <>
      <Navbar />

      <main>
        <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20abstract%20art%20with%20flowing%20ink%20splashes%20in%20warm%20amber%20and%20coral%20tones%2C%20with%20subtle%20comic%20panel%20lines%20fading%20into%20background%2C%20artistic%20gradient%20with%20soft%20paper%20texture%2C%20elegant%20minimalist%20Japanese%20Korean%20illustration%20aesthetic%2C%20warm%20glow%20effect%20from%20center%2C%20no%20text%2C%20clean%20composition&width=1920&height=900&seq=hero-bg-2026&orientation=landscape"
            alt="韩漫屋 - 韩国漫画在线阅读"
            title="韩漫屋 - 韩漫免费看 下拉式漫画大全"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40" />

          <div className="relative z-10 w-full container-custom py-20 md:py-28">
            <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-4">
                韩漫免费看
                <br className="hidden sm:block" />
                下拉式漫画大全
              </h1>
              <p className="text-sm md:text-base text-background-200/90 max-w-xl mb-8 leading-relaxed">
                {siteConfig.description}
              </p>
              <div className="flex items-center gap-4">
                <Link
                  to="/category/all"
                  className="px-7 py-3 text-sm font-semibold rounded-full bg-background-950/90 text-background-50 hover:bg-background-950 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  立即阅读
                </Link>
                <a
                  href="#featured"
                  className="px-7 py-3 text-sm font-medium rounded-full border border-background-50/40 text-background-50 hover:bg-background-50/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  查看榜单
                </a>
              </div>
            </div>

            <div className="hidden md:flex items-end justify-center gap-4 mt-16">
              {featuredComics.slice(0, 6).map((comic, i) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="flex-shrink-0 cursor-pointer"
                  style={{
                    transform: `translateY(${i === 0 || i === 5 ? '24px' : i === 1 || i === 4 ? '12px' : '0px'})`,
                  }}
                  data-product-shop
                >
                  <div className="w-[90px] md:w-[110px] aspect-[3/4] rounded-xl overflow-hidden bg-background-300">
                    <img
                      src={comic.coverImage}
                      alt={comic.title}
                      title={`${comic.title} - 韩漫免费看`}
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section id="featured" className="py-14 md:py-18">
          <div className="container-custom">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-10">
              <i className="ri-fire-line mr-2 text-accent-500"></i>
              热门分类推荐
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
              {featuredComics.slice(0, 3).map((comic) => (
                <ComicCardFeatured
                  key={comic.id}
                  id={comic.id}
                  title={comic.title}
                  description={comic.description}
                  coverImage={comic.coverImage}
                  rating={comic.rating}
                  chapters={comic.chapters}
                  status={comic.status}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12">
          <div className="container-custom">
            <div className="flex flex-wrap items-center justify-between mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                本周强推
              </h2>
              <Link
                to="/category/all"
                className="text-sm text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {hotComics.map((comic) => (
                <ComicCard
                  key={comic.id}
                  id={comic.id}
                  title={comic.title}
                  author={comic.author}
                  category={comic.category}
                  rating={comic.rating}
                  views={comic.views}
                  chapters={comic.chapters}
                  status={comic.status}
                  coverImage={comic.coverImage}
                  tags={comic.tags}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12 bg-background-100">
          <div className="container-custom">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-8 md:mb-10">
              漫画分类
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group flex flex-col items-center gap-2 p-5 rounded-xl bg-background-50 hover:bg-primary-50 transition-all duration-200 cursor-pointer"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50">
                    <i className={`ri-${
                      cat.slug === 'all' ? 'book-3-line' :
                      cat.slug === 'hot-blood' ? 'fire-line' :
                      cat.slug === 'romance' ? 'heart-3-line' :
                      cat.slug === 'fantasy' ? 'sparkling-line' :
                      cat.slug === 'drama' ? 'theater-line' :
                      cat.slug === 'thriller' ? 'ghost-line' :
                      cat.slug === 'comedy' ? 'emoji-laugh-line' :
                      'sword-line'
                    } text-primary-600 text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                    {cat.name}
                  </span>
                  <span className="text-xs text-foreground-500">{cat.count}部</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-8 md:py-12">
          <div className="container-custom">
            <div className="flex flex-wrap items-center justify-between mb-8 md:mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                最新更新
              </h2>
              <Link
                to="/category/all"
                className="text-sm text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {latestComics.map((comic) => (
                <ComicCard
                  key={comic.id}
                  id={comic.id}
                  title={comic.title}
                  author={comic.author}
                  category={comic.category}
                  rating={comic.rating}
                  views={comic.views}
                  chapters={comic.chapters}
                  status={comic.status}
                  coverImage={comic.coverImage}
                  tags={comic.tags}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-950">
          <div className="container-custom">
            <div className="flex flex-col items-center text-center max-w-2xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
                随时随地追更韩漫
              </h2>
              <p className="text-sm text-foreground-400 mb-8 leading-relaxed">
                支持手机、平板、电脑全平台阅读，下拉式体验，畅快追更韩国漫画
              </p>
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-8 py-3 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                开始阅读之旅 <i className="ri-arrow-right-line"></i>
              </Link>
              <div className="mt-12 grid grid-cols-3 gap-6 md:gap-10 max-w-xl">
                {[
                  { icon: 'ri-smartphone-line', label: '手机端', desc: '随时随地阅读' },
                  { icon: 'ri-tablet-line', label: '平板端', desc: '大屏畅快体验' },
                  { icon: 'ri-computer-line', label: '电脑端', desc: '沉浸式阅读' },
                ].map((device) => (
                  <div key={device.label} className="flex flex-col items-center gap-2">
                    <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-background-800 flex items-center justify-center mb-1">
                      <i className={`${device.icon} text-2xl text-foreground-300`}></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-300">{device.label}</span>
                    <span className="text-xs text-foreground-500">{device.desc}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebPage',
              name: '韩漫屋 - 韩漫免费看 下拉式漫画大全',
              description: siteConfig.description,
              url: siteConfig.url,
              isPartOf: {
                '@type': 'WebSite',
                name: siteConfig.name,
                url: siteConfig.url,
              },
              about: {
                '@type': 'Thing',
                name: '韩国漫画在线阅读',
              },
            }),
          }}
        />
      </main>

      <Footer />
    </>
  );
}